module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/arizona-44e42e5ab06cce0ad6f344b0c1cb3f20.jpg";